import { combineReducers } from 'redux';
import data from './data';
import auth from './authReducer';
import filter from './filter';
import view from './view';

export default combineReducers({
  data,
  filter,
  auth,
  view,
});
